import React, { useEffect, useMemo, useState } from "react";
import { Input } from "@progress/kendo-react-inputs";
import PropTypes from "prop-types";
import { number } from "../../../../config";
import RightProfileDropdown from "./RightProfileDropdown";

/**
 * ProfileControlField component handles different types of profile controls
 * Parent component: RightProfilePanel
 * based on the ProfileControls data structure
 * @author Bhavana
 */
const ProfileControlField = ({ control, profileControlsDataList, user, profileData, handleChange, uId, error }) => {
  const isDisabled = !control?.isEditable;
  const ariaDescribedBy = error ? `${control?._id}-error` : undefined;
  const [textValue, setTextValue] = useState(control?.value);

  // Sync textValue with control value when it changes from parent
  useEffect(() => {
    setTextValue(control?.value);
  }, [control?.value]);

  if (control?.isFixedType || control?.variableType === "dropdown") {
    return (
      <>
        <RightProfileDropdown
          dropdownData={control?.options || []}
          handleChange={handleChange}
          title={control?.name}
          dropdownValue={control?.options?.find((option) => option?.value === control?.value)}
          keyName={control?._id}
          disabled={isDisabled}
          aria-label={control?.name}
          aria-describedby={ariaDescribedBy}
        />
        {error && (
          <div className='text-danger small mt-1' id={ariaDescribedBy}>
            {error}
          </div>
        )}
      </>
    );
  }

  if (!control?.isFixedType && control?.variableType === "text") {
    const attributes = control?.attributes || {};
    if (textValue === undefined || textValue === null) {
      setTextValue(attributes?.defaultValue ?? "");
    }

    const handleTextChange = (event) => {
      let value = event.target.value;
      setTextValue(value);
      handleChange(event);
    };

    return (
      <div className='form-group'>
        <label htmlFor={`rightprofilepanel-${control?._id}`}>{control?.name}</label>
        {attributes?.required && <sup className='text-danger'>*</sup>}
        <Input
          className='w-100'
          placeholder={attributes?.placeholder || ""}
          disabled={isDisabled}
          name={control?._id}
          value={textValue}
          onChange={handleTextChange}
          maxLength={attributes?.max}
          minLength={attributes?.min}
          id={`rightprofilepanel-${control?._id}`}
          aria-label={control?.name}
          aria-describedby={ariaDescribedBy}
        />
        {error && (
          <div className='text-danger small mt-1' id={ariaDescribedBy}>
            {error}
          </div>
        )}
      </div>
    );
  }
  return null;
};

ProfileControlField.propTypes = {
  control: PropTypes?.object?.isRequired,
  profileControlsDataList: PropTypes?.object,
  user: PropTypes?.object,
  profileData: PropTypes?.object,
  handleChange: PropTypes?.func?.isRequired,
  uId: PropTypes?.any,
  error: PropTypes?.string,
};

export default ProfileControlField;
